import { useSelector } from 'react-redux';
import { getPaymentsById, getPaymentByUrl } from 'ContentData/selectors/payments';
import Payment from 'ContentComponents/cmv2/fields/Payment';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentSelect = ({
  onChange,
  required,
  value
}) => {
  const paymentsById = useSelector(getPaymentsById) || {};
  const selectedPayment = useSelector(state => {
    return getPaymentByUrl(state, {
      url: value
    });
  });
  const onSelect = paymentValue => {
    const {
      id
    } = paymentValue || {};
    const payment = paymentsById[id];
    onChange(payment ? payment.checkoutUrl : '');
  };
  return /*#__PURE__*/_jsx(Payment, {
    onFieldChange: onSelect,
    required: required,
    value: selectedPayment ? {
      id: selectedPayment.id
    } : undefined
  });
};
export default PaymentSelect;